<template>
  <div class="player-box" :style="{height: height + 'px'}">
    <video-inner @user-close="userCloseCallback" ref="inner" v-bind="$attrs" v-on="$listeners" :resize="resize">
      <template #other>
        <slot name="other"></slot>
      </template>
    </video-inner>
  </div>
</template>

<script>

export default {
  name: 'VideoBox',
  props: {
    scrollQuery: {
      type: String,
      default: '#app'
    },
    resize:{//右侧栏
      type: Boolean,
      default: false
    },
  },
  watch: {
    resize () {
      this.changeResize();
    }
  },
  data () {
    return {
      height: '',
      body: document.body,
      userClose: false,
    };
  },
  methods: {
		fullScreen(){
			this.$nextTick(() => {
				let inner = this.$refs.inner;
				inner.fullScreen();
			})
		},
    changeResize () {
      this.$nextTick(() => {
        let inner = this.$refs.inner;
        inner = inner.$el || inner;
        this.height = inner.getBoundingClientRect().height;
      })
    },
    userCloseCallback () {
      this.userClose = true;
    },
    showPicture (config) {
      if (this.userClose && config === true) {
        return;
      } else if (config === false) {
        this.userClose = false;
      }
      this.$refs.inner.showPicture(config);
    },
    scrollCallback (e) {
      let { bottom } = this.$el.getBoundingClientRect();
      this.showPicture(bottom <= 0);
    },
  },
  created () {
  },
  beforeDestroy () {
    this.body.removeEventListener('scroll', this.scrollCallback);
  },
  mounted () {
    this.$nextTick(() => {
      let inner = this.$refs.inner;
      inner = inner.$el || inner;
      this.height = inner.getBoundingClientRect().height;
      this.body = this.scrollQuery ? document.querySelector(this.scrollQuery) : document.body;
      this.body.addEventListener('scroll', this.scrollCallback);
    })
  },
}
</script>

<style scoped lang="less">
.player-box {
  background-color: #000;
}
</style>
